(function () {
    'use strict';

    angular.module(
        'quantixApp',
        ['ngStorage', 'tmh.dynamicLocale', 'pascalprecht.translate',
            'ngResource', 'ngCookies', 'ngAria', 'ngCacheBuster',
            'ngFileUpload', 'ui.bootstrap',
            'ui.bootstrap.datetimepicker', 'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add
            // new module here
            'angular-loading-bar', 'ivh.treeview', 'fdGrid', 'plotly',
            'rzModule', 'dndLists', 'ngAnimate', 'ngSanitize',
            'ui.bootstrap', 'gcspreadsheets', 'scrollable-table',
            'vcRecaptcha', 'angular.chosen', 'ngIdle', 'ngCanvasGauge',

            'angucomplete-alt', 'duScroll', 'nya.bootstrap.select',

            'ngSlimScroll', 'uiGmapgoogle-maps', 'ui.multiselect'

            , 'ngListSelect', 'isteven-multi-select',

            'obDateRangePicker', 'ui.toggle', 'amChartsDirective',
            'duScroll', 'ui.multiselectPortfolioModule',
            'checklist-model', 'angularMoment', 'ngLetterAvatar',
            'ngRoute', 'angular-inview', 'oc.lazyLoad','slickCarousel'
        ]).value('duScrollOffset', 120);

    angular.module('quantixApp').directive('numbersOnly', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        if (text.indexOf('.') == 0) {
                            transformedInput = '';
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        var transformedInput = text.replace(/[^-0-9.]/g, '');
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        if (transformedInput.split(".").length > 2) {
                            var tempArr = transformedInput.split(".", 2);
                            transformedInput = tempArr[0] + "." + tempArr[1];
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return undefined;
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });

    angular.module('quantixApp').directive('loadingnew', function () {
        return {

            restrict: 'E',
            replace: 'true',
            scope: {
                loadingvariable: '='
            },
            template: '<div class="loading"></div>',
            link: function ($scope, element, attributes) {
                $scope.$watch('loadingvariable', function (val) {
                    $('.loading').loadingdots();
                    if (val)
                        $(element).show();
                    else
                        $(element).hide();
                });

            }
        };
    });

    angular
        .module('quantixApp')
        .directive(
            'removeSplChar',
            function () {
                return {
                    require: 'ngModel',
                    link: function (scope, element, attr, ngModelCtrl) {
                        function fromUser(text) {
                            if (text) {
                                if (text.indexOf('.') == 0) {
                                    transformedInput = '';
                                    ngModelCtrl
                                        .$setViewValue(transformedInput);
                                    ngModelCtrl.$render();
                                }
                                var transformedInput = text
                                    .replace(
                                        /[<>@#$?$&()'\"/*;:={}%+^!`|]/g,
                                        '');
                                if (transformedInput !== text) {
                                    ngModelCtrl
                                        .$setViewValue(transformedInput);
                                    ngModelCtrl.$render();
                                }
                                if (transformedInput.split(".").length > 2) {
                                    var tempArr = transformedInput
                                        .split(".", 2);
                                    transformedInput = tempArr[0] + "." +
                                        tempArr[1];
                                    ngModelCtrl
                                        .$setViewValue(transformedInput);
                                    ngModelCtrl.$render();
                                }
                                return transformedInput;
                            }
                            return undefined;
                        }
                        ngModelCtrl.$parsers.push(fromUser);
                    }
                };
            });

    angular
        .module('quantixApp')
        .directive(
            'numberBm',
            function () {
                return {
                    require: 'ngModel',
                    link: function (scope, element, attr, ngModelCtrl) {
                        function fromUser(text) {
                            if (text) {

                                if (text.indexOf('.') == 0) {
                                    transformedInput = '';
                                    ngModelCtrl
                                        .$setViewValue(transformedInput);
                                    ngModelCtrl.$render();
                                }

                                var transformedInput = text.replace(
                                    /[^0-9.+-]/g, '');

                                if (transformedInput !== text) {
                                    ngModelCtrl
                                        .$setViewValue(transformedInput);
                                    ngModelCtrl.$render();
                                }

                                if (transformedInput.split(".").length > 2) {
                                    var tempArr = transformedInput
                                        .split(".", 2);
                                    transformedInput = tempArr[0] + "." +
                                        tempArr[1];
                                    ngModelCtrl
                                        .$setViewValue(transformedInput);
                                    ngModelCtrl.$render();
                                }

                                if (transformedInput.includes("-")) {

                                    if (transformedInput.indexOf("-") != 0) {
                                        transformedInput = transformedInput
                                            .split("-")[0];
                                        ngModelCtrl
                                            .$setViewValue(transformedInput);
                                        ngModelCtrl.$render();

                                    } else {
                                        var stringsearch = "-",
                                            str = transformedInput,
                                            count = 0;
                                        for (var i = 0; i < str.length; count += +(stringsearch === str[i++]))
                                        ;
                                        if (count > 1) {
                                            transformedInput = transformedInput
                                                .charAt(0);
                                            ngModelCtrl
                                                .$setViewValue(transformedInput);
                                            ngModelCtrl.$render();
                                        }
                                    }
                                }

                                if (transformedInput.includes("+")) {

                                    if (transformedInput.indexOf("+") != 0) {
                                        transformedInput = transformedInput
                                            .split("+")[0];
                                        ngModelCtrl
                                            .$setViewValue(transformedInput);
                                        ngModelCtrl.$render();

                                    } else {
                                        var stringsearch = "+",
                                            str = transformedInput,
                                            count = 0;
                                        for (var i = 0; i < str.length; count += +(stringsearch === str[i++]))
                                        ;
                                        if (count > 1) {
                                            transformedInput = transformedInput
                                                .charAt(0);
                                            ngModelCtrl
                                                .$setViewValue(transformedInput);
                                            ngModelCtrl.$render();
                                        }
                                    }
                                }

                                return transformedInput;
                            }
                            return undefined;
                        }
                        ngModelCtrl.$parsers.push(fromUser);
                    }
                };
            });

    angular.module('quantixApp').directive('isCbEnabled', function () {
        return {
            link: function (scope, element, attrs) {
                if (scope.node.disabled) {
                    // element.find('input').attr('disabled', true);

                    element.find('input').css("cursor", "not-allowed");
                }
            }
        };
    });
    // for coping table to clip board
    angular.module('quantixApp').directive('copyToClipboard', function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.click(function () {
                    var el = document.getElementById(attrs.copyToClipboard);
                    var body = document.body,
                        range, sel;
                    if (document.createRange && window.getSelection) {
                        range = document.createRange();
                        sel = window.getSelection();
                        sel.removeAllRanges();
                        try {
                            range.selectNodeContents(el);
                            sel.addRange(range);
                        } catch (e) {
                            range.selectNode(el);
                            sel.addRange(range);
                        }
                        document.execCommand("copy");

                    }

                });
            }
        };
    });

    angular
        .module('quantixApp')
        .directive(
            'isNumber',
            function () {
                return {
                    require: 'ngModel',
                    scope: {
                        options: '=',
                        model: '=ngModel'
                    },
                    replace: true,
                    link: function (scope) {
                        scope
                            .$watch(
                                "model",
                                function (newValue, oldValue) {
                                    var arr = String(newValue)
                                        .split("");
                                    if (arr.length === 0)
                                        return;
                                    if (arr.length === 1 &&
                                        (arr[0] === '-' ||
                                            arr[0] === '.' ||
                                            arr[0] === '+' || arr[0] === '-'))
                                        return;
                                    if (arr.length === 2 &&
                                        newValue === '-.')
                                        return;
                                    if (isNaN(newValue)) {
                                        scope.model = oldValue;
                                    }
                                });
                    }
                };
            }).constant('BENCHMARKS', 'Benchmarks').constant(
            'BUSINESS_INFORMATION', 'Business Information').constant(
            'COMPANY', 'Company').constant('CREDIT_RATING_DETAILS',
            'Credit Rating Details').constant(
            'CREDIT_RISK_INDICATOR_MODEL',
            'Credit Risk Indicator Model').constant(
            'CREDIT_SENSITIVITY_MODEL', 'Credit Sensitivity Model')
        .constant('EQUITY_DETAILS', 'Equity Details').constant(
            'FINANCIAL_INFORMATION', 'Financial Information').constant(
            'FINANCIAL_SENSITIVITY_MODEL',
            'Financial Sensitivity Model').constant(
            'FIXED_INCOME_SECURITIES', 'Fixed Income Securities')
        .constant('IRS', 'IRS').constant('INDUSTRY', 'Industry').constant(
            'NEWS', 'News').constant('NOTIFICATIONS', 'Notifications')
        .constant('OTHER_DETAILS', 'Other details').constant('PORTFOLIO',
            'Portfolio').constant('PROJECTIONS_AND_CMATOOL',
            'Projections & CMA Tool').constant('QUICK_SCREENING_TOOL',
            'Quick Screening Tool').constant('RATING_LIST',
            'Rating List').constant('REPORT_BUILDER', 'Report Builder')
        .constant('SME_MARGIN', 'SME Margin').constant('SCORECARD',
            'Scorecard').constant('EXPORT_FSM', 'Export FSM').constant(
            'COMPANY_PROFILE', 'Company Profile-Landing').constant(
            'COMPANY_PROFILE_PEERCOMPARISON',
            'Company Profile-Peer Comparison').constant(
            'COMPANY_PROFILE_SCORECARD', 'Company Profile-Scorecard')
        .constant('COMPANY_PROFILE_CAPINFO',
            'Company Profile-Capital Market Information').constant(
            'COMPANY_PROFILE_RATINGINFO',
            'Company Profile-Rating Information').constant(
            'INDUSTRY_PROFILE', 'Industry Profile').constant(
            'ADVANCE_SEARCH', 'Advance Search').constant(
            'CREATE_PORTFOLIO', 'Create Portfolio').constant(
            'PORTFOLIO_DASHBOARD', 'Portfolio View').constant(
            'PORTFOLIO_COMPARE', 'Portfolio Compare').constant(
            'REPORT_BUILDER', 'Report Builder').constant(
            'COMPANY_FINANCIAL', 'Company Financial').constant('NEWS',
            'News').constant('ALERT', 'Alert').constant(
            'MAX_ROWS_EXPORT', '1000').constant('MAX_COLUMN_EXPORT',
            '59').constant('RATING_LIST', 'Rating List').constant(
            'CREDIT_PORTFOILO', 'Credit portfolio').constant(
            'FSM_UNLISTED_MODEL', 'FSM Unlisted').constant(
            'COMPANY_REPORT', 'Company Report').constant('FAM_MODULE', 'FAM').run(run).config(config);

    run.$inject = ['stateHandler', 'translationHandler', 'Idle', '$rootScope',
        '$uibModal', 'Auth', '$state', 'AuthTrackerProvider', '$http'
    ];
    config.$inject = ['$translateProvider', 'cfpLoadingBarProvider'];

    function run(stateHandler, translationHandler, Idle, $rootScope, $uibModal,
        Auth, $state, AuthTrackerProvider, $http) {
        stateHandler.initialize();
        translationHandler.initialize();

        $rootScope.started = false;

        function closeModals() {
            if ($rootScope.warning) {
                $rootScope.warning.close();
                $rootScope.warning = null;
            }

            if ($rootScope.timedout) {
                $rootScope.timedout.close();
                $rootScope.timedout = null;
            }
        }

        $rootScope.$on('IdleStart', function () {
            closeModals();

            $rootScope.warning = $uibModal.open({
                templateUrl: 'warning-dialog.html',
                windowClass: 'modal-danger'
            });
        });



        $rootScope.$on('IdleEnd', function () {
            closeModals();
            AuthTrackerProvider.dummyMethodCalling().then(function (response) {
                var sucussRes = response.data[0];
            })["catch"](function () {

            });
        });

        $rootScope.$on('IdleTimeout', function () {
            closeModals();
            var status = "Session Timeout";
            $http.post('api/userTracker/logouttrackingdetails', status).then(
                function () {

                    Auth.logout();
                    $rootScope.$emit("peerCompUibModalClose");
                    $state.go('login');
                })["catch"](function () {
                Auth.logout();
                $rootScope.$emit("peerCompUibModalClose");
                $state.go('login');
            });

            $rootScope.timedout = $uibModal.open({
                templateUrl: 'app/layouts/navbar/sessiontimeout.html',
                controller: 'SessionTimeOut as vm',
                windowClass: 'large-Modal'
            });
        });



        $rootScope.start = function () {
            closeModals();
            Idle.watch();
            $rootScope.started = true;
        };

        $rootScope.stop = function () {
            closeModals();
            Idle.unwatch();
            $rootScope.started = false;
        };
    }

    var translations_en = {};

    function config($translateProvider, cfpLoadingBarProvider) {
        cfpLoadingBarProvider.spinnerTemplate = '';
        cfpLoadingBarProvider.loadingBarTemplate = '<div class="modal" modal-in-class="in" style="z-index: 1050; display: block;"><div id="loading-bar" class=""><div class="loadermodal"><div class="cs-loader">' +
        '<div class="cs-loader-inner"><div class="loader-veiw"></div></div>' +
            '</div></div></div></div>';
        translations_en = {};
        $translateProvider.translations('en', translations_en);
        $translateProvider.preferredLanguage('en');

    }

    angular.module('quantixApp').directive('appLoaded',['$window',function($window){
        return {
             restrict:'A',
             link:function(scope,element,attrs){
                 $window.localStorage['istermsviewed']=JSON.stringify(false);
             }
         };
     }]);

     angular.module('quantixApp').directive('myDirec', ['$log', '$templateCache', '$compile', function($log, $templateCache, $compile) {
        return {
          restrict: 'A',
         
          link: function(scope, element, attr) {
                  element.children().attr('data-toggle', 'tooltip');
                  element.children().attr('data-placement', 'tooltip');
                  element.children().attr('title', 'hello tool tip');
          },
        };
      }]);
})();
